<div (clickOutside)="closeActionMenu($event)" class="cell-menu-container">
  @if (enableCellMenu) {
    <div
      (click)="toggleMenu($event)"
      attr.name="RowDots_{{ item.name }}"
      class="dots"
      id="RowDots_{{ item.id }}"
      >
      ...
    </div>
  }
</div>
